import isEmpty from 'lodash/isEmpty';
import { isServerSide } from 'helpers/ssr';

// Access to GTM dataLayer as React variable
export const dataLayer = !isServerSide() ? window.dataLayer || [] : [];

/**
 * Push data to dataLayer
 *
 * @param {object} data
 */
export const pushToDataLayer = (data) => {
    if (isServerSide()) {
        return;
    }

    window.dataLayer = dataLayer;
    window.dataLayer.push(data);
};

export function ga4event(eventName, eventData) {
    try {
        dataLayer.push({
            event: eventName,
            ...eventData
        });
    } catch {}
}

/**
 * Push event to dataLayer
 *
 * @param {string} eventName
 * @param {object|null} eventInfo
 * @param {object} data
 */
export const pushEventToDataLayer = (eventName, eventInfo = null, data) => {
    const eventData = {
        event: eventName,
        ...data
    };

    if (!isEmpty(eventInfo)) {
        eventData.event_info = { ...eventInfo };
    }

    pushToDataLayer(eventData);
};

/**
 * Push GA event to dataLayer
 *
 * @param {string|null} category
 * @param {string|null} action
 * @param {string|null} label
 * @param {string|null} value
 * @param {object|null} gaData
 * @param {object|null} additionalEventInfo
 */
export const pushGAEventToDataLayer = (
    category = null,
    action = null,
    label = null,
    value = null,
    gaData = {},
    additionalEventInfo = {}
) => {
    const eventData = {
        event: 'ga_event',
        event_info: {
            type: 'ua',
            category,
            action,
            label,
            value,
            non_interaction: 1,
            ...additionalEventInfo
        },
        ...gaData
    };

    pushToDataLayer(eventData);
};
